module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloudy-f22cdbab.svg";